import React, { InputHTMLAttributes } from 'react';
import { dateMask } from 'shared/Inputs/inputMasks';
import InputTextMask from 'react-text-mask';
import { Input } from 'form/components';
import { FormInput } from 'form/FormInput';
import useTextMaskRefConnect from 'form/useTextMaskRefConnect';

interface Props extends InputHTMLAttributes<HTMLInputElement>, FormInput {
  wrapperStyle?: React.CSSProperties;
}

const DateInput = React.forwardRef<HTMLInputElement, Props>(({ wrapperStyle, ...props }, ref) => {
  const [connectRef] = useTextMaskRefConnect(ref);

  return (
    <div style={wrapperStyle}>
      <InputTextMask
        mask={dateMask}
        guide={false}
        {...props}
        render={(textMaskRef, innerProps) => <Input ref={connectRef(textMaskRef)} {...innerProps} />}
      />
    </div>
  );
});

export default DateInput;
